import PageWrapper from "@components/UI/PageWrapper/Index";
import { useGenericReducer } from "@hooks/state/useGenericReducer";
import FiltroUsuarios from "@components/Usuario/Filter/Index";
import CreateUsuarios from "@components/Usuario/Create/Index";

const PageUsuarios = () => {
    const { state, setData, addItem, updateItem, deleteItem } = useGenericReducer();

    return (
        <PageWrapper>
            <CreateUsuarios
                addItem={addItem}
            />
            <FiltroUsuarios
                state={state}
                setData={setData}
                deleteItem={deleteItem}
                updateItem={updateItem}
            />
        </PageWrapper>
    );
};

export default PageUsuarios;